import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Table } from "capitalrx-components";
import { useLocation } from "react-router";
import { drugSearchActions } from "@/App/actions";

import { removeDrugAction } from "@/App/actions/appActions/drug/remove";
import { RootState } from "@/App/reducers";
import { getDrugsFromQueryString } from "@/App/utils/utils";
import { DrugResult } from "@/types/appTypes/drug";
import { queryString } from "capitalrx-utilities";

import tableHeaders from "./SelectedDrugTableHeaders";

const SelectedDrugsTable: React.FC = () => {
  const { selectedDrugs } = useSelector((state: RootState) => state.drug);
  const dispatch = useDispatch();
  const { search } = useLocation();
  const { drugs } = queryString.getQueryParams(search);
  const { searchForSelectedDrugs } = drugSearchActions;

  const currentDrugs = getDrugsFromQueryString(drugs);

  const tableSelectedHeader = "Drug Selection";

  useEffect(() => {
    // take the current drugs and go get their info
    if (currentDrugs) {
      dispatch(searchForSelectedDrugs({
        data: currentDrugs,
        formName: "testClaimDrugSearch",
      }));
    }
  }, []);

  const handleRemoveDrug = (drug: DrugResult): void => {
    dispatch(removeDrugAction(drug));
  };

  return (
    <div className="selected-drugs-table">
      <div className="table-section-selected-header">{tableSelectedHeader}</div>
      <Table data={selectedDrugs} headers={tableHeaders} className="claim-test-search-list" onClick={handleRemoveDrug} />
    </div>
  );
};

export default SelectedDrugsTable;
